import { Serializable } from '../../core/models/serializable';
export class OccupationCategory implements Serializable<OccupationCategory> {
  public occupationCategoryId: number;
  public head: OccupationCategory;
  public headId: number;
  public name: string;
  public isHead: boolean;

  public isHeadOld(): boolean {
    return this.headId == this.occupationCategoryId || this.isHead;
  }

  fromObject(obj: any): OccupationCategory {
    Object.assign(this, obj);
    if (obj.head != null) {
      this.headId = obj.head.occupationCategoryId;
    }

    return this;
  }
  toObject() {
    throw new Error('Method not implemented.');
  }
}
